import { apiGetSharePriceHistory, apiDeleteSharePrice } from "../../../utils/api/api";

/**
 * SharePriceService
 * Centralizes API interactions for share price history management.
 * Provides methods for fetching, editing, and deleting share price records.
 */
const SharePriceService = {
    /**
     * Fetches share price history for a scheme
     * 
     * @param {string} oppRid - The opportunity/scheme ID
     * @returns {Promise} Promise with the share price history data
     */
    getSharePriceHistory: (oppRid) => {
        return apiGetSharePriceHistory({ oppRid });
    },
    /**
     * Deletes a share price record
     * 
     * @param {string} spuRid - The share price update record ID
     * @returns {Promise} Promise with the deletion response
     */
    deleteSharePrice: (spuRid) => {
        return apiDeleteSharePrice({ spuRid });
    }
};

export default SharePriceService;